import { render, staticRenderFns } from "./rema-cropper.vue?vue&type=template&id=0ff67834&scoped=true"
import script from "./rema-cropper.vue?vue&type=script&lang=js"
export * from "./rema-cropper.vue?vue&type=script&lang=js"
import style0 from "./rema-cropper.vue?vue&type=style&index=0&id=0ff67834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff67834",
  null
  
)

export default component.exports